import {Component, prop, watch} from 'vue-property-decorator';

export var filtersService = window.filters || {
    nutrient_type: [true, true],
    fes: 0,
    weight_unit: 0,
    energy_unit: [true, true, true],
    ratio: [true, true],
};

@Component({
    template: require('./filters.html'),
    components: {

    }
})
export class Filters {
    filters = filtersService;

    @prop(Array)
    subspecies_list;

    @prop(Number)
    id;

    name = '';
    value  = '';

    change_species(event) {
        this.$emit('change_species', event.target.value);
    }

    get id_val() {
        return this.id;
    }

    mounted() {
        this.value = JSON.stringify(this.filters);
    }

    change(e) {
        this.value = JSON.stringify(this.filters);
        this.$emit('change');
    }
}
